module.exports = "query getAvailableSites($uri:[String],$site:[String]){entries(site:$site,section:\"towers\",type:\"towers\",uri:$uri){title siteHandle}}"